import styled from 'styled-components';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
import { WizardList } from '../../../components/Wizard/WizardList';
import { Flex } from 'foundations-components/components/Flex';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "WizardChooseMotivation__Container",
  componentId: "i39xp4-0"
})(["line-height:1.2;"]);
export const WizardChooseMotivation = ({
  resultCountTotal,
  searchCriteria,
  onMotivationClick
}) => {
  const {
    totalCount: resultCountTotalCertsOnly
  } = useSearch({
    variables: Object.assign({}, searchCriteria, {
      hasAwardsOnly: true
    })
  });
  const trackButtonClick = certsOnly => {
    UsageTracker.track('wizardInteraction', {
      action: certsOnly ? 'wizard-click-show-certs-only' : 'wizard-click-show-all-courses',
      resultCount: certsOnly ? resultCountTotalCertsOnly : resultCountTotal
    });
  };
  return /*#__PURE__*/_jsxs(WizardList, {
    children: [/*#__PURE__*/_jsx(SelectableBox, {
      block: true,
      "data-test-id": "show-certs-only-button",
      flush: true,
      height: 56,
      onClick: () => {
        onMotivationClick(true);
        trackButtonClick(true);
      },
      readOnly: resultCountTotalCertsOnly < 1,
      type: "default",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          paddingBlockStart: "200",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.wizard.modal.motivationbuttons.advancecareer"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.wizard.modal.motivationbuttons.showcertscount`,
                options: {
                  totalCount: resultCountTotalCertsOnly
                }
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SelectableBox, {
      block: true,
      "data-test-id": "show-all-button",
      flush: true,
      height: 56,
      onClick: () => {
        onMotivationClick(false);
        trackButtonClick(false);
      },
      type: "default",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          paddingBlockStart: "200",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.wizard.modal.motivationbuttons.currenttrends`
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.wizard.modal.motivationbuttons.showallcount`,
                options: {
                  totalCount: resultCountTotal
                }
              })
            })
          })]
        })
      })
    })]
  });
};
export default WizardChooseMotivation;